import { CartSvg, CrossSvg, FootballSvg } from '../../svgFile';
import { Link, useNavigate } from 'react-router-dom';
import CartItem from './CartItem';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectCartItems, selectCartSubtotal,
  removeCartItem,
  updateCartItem,
  fetchCart
} from '../../store/slices/cartSlice';
import { useEffect } from 'react';
import { useAuth } from '../hooks/IsAuth';

const CartSidebar = ({
  isOpen = false,
  onClose,
  onCustomize,
  customItems = null,
  customOnRemove = null,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { isLoggedIn } = useAuth()
  const reduxItems = useSelector(selectCartItems);
  const subtotal = useSelector(selectCartSubtotal);
  const items = customItems || reduxItems;
  useEffect(() => {
    if (isLoggedIn) {
      dispatch(fetchCart());
    }
  }, [dispatch, isLoggedIn]);
  const handleRemoveItem = (itemId, productId) => {
    if (customOnRemove) {
      customOnRemove({itemId: itemId, productId: productId});
    } else {
      dispatch(removeCartItem({itemId: itemId, productId: productId}));
    }
  };
  const handleUpdateQuantity = (itemId, newQuantity) => {
    if (newQuantity < 1) {
      handleRemoveItem(itemId);
      return;
    }
    if (!customItems) {
      dispatch(updateCartItem({ itemId, quantity: newQuantity }));
    }
  };
  const calculateSubtotal = () => {
    if (!customItems) {
      return subtotal;
    }
    return items.reduce((total, item) => {
      const price = Number(item?.price) || 0;
      const quantity = Number(item?.quantity) || 0;
      return total + (price * quantity);
    }, 0);
  };
  const offcanvasClass = isOpen ? "offcanvas offcanvas-end cart-sidbar show" : "offcanvas offcanvas-end cart-sidbar";
  return (
    <div
      className={offcanvasClass}
      tabIndex={-1}
      id="cartSidebar"
      aria-labelledby="cartSidebarLabel"
      style={isOpen ? { visibility: 'visible' } : {}}
    >
      <div className="offcanvas-header d-flex align-items-center justify-content-between">
        <h5 className="offcanvas-title" id="offcanvasExampleLabel">
          Shopping cart
        </h5>
        <button
          type="button"
          className="close-btn"
          onClick={onClose}
          aria-label="Close"
        >
          Close <CrossSvg />
        </button>
      </div>
      <div className="offcanvas-body mt-2">
        {items?.length === 0 ? (
          <div className="text-center py-5">
            <p>Your cart is empty</p>
            <Link to="/choose-item-option" className="btn gradient-btn mt-3" onClick={onClose}>
              Start Shopping
            </Link>
          </div>
        ) : (
          items?.map((item, i) => (
            <CartItem
              key={i}
              item={item}
              onRemoveItem={() => handleRemoveItem(item.id)}
              onUpdateQuantity={(newQuantity) =>
                handleUpdateQuantity(item.id, newQuantity)
              }
              showQuantityControls={!customItems}
            />
          ))
        )}
      </div>
      {items?.length > 0 && (
        <div className='offcanvas-footer white-card-footer'>
          <div className='d-flex align-items-center justify-content-between '>
            <h3 className="mb-0">Subtotal</h3>
            <h3 className='mb-0 link-text'>${calculateSubtotal().toFixed(2)}</h3>
          </div>
          <div className="mt-4 d-flex align-items-center gap-3 product-detail-btns-wrap">
            <Link
              to='/cart-details'
              className="btn gradient-btn w-100"
              onClick={() => {
                onClose();
              }}
            >
              <span className="me-2"><CartSvg /></span>View Cart
            </Link>
            <button
              className="btn purple-btn w-100"
              onClick={() => {
                onClose();
                navigate('/checkout')
              }}
            >
              <span className="me-2"><FootballSvg /> </span>Checkout
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartSidebar;